import React from 'react';

function HomePage() {
    return (
        <div className='vh-10 overflow-hide d-flex justify-content-center align-items-center'>
            <h1 className='text-muted fw-bold'>Welcome Back</h1>
        </div>
    );
}

export default HomePage;
